// src/modules/app-views/toolbox/pages/Document/tabs/ReferencesTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import translateX from 'utils/translateX';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';
import ReferencesCard from './components/ReferencesCard';
import SearchTermsCard from './components/SearchTermsCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ToolboxReferencesTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading, viewMode, refresh } = useDocumentContext() || {};

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const disabled = viewMode === 'view';

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="toolboxReferences" isFetching={loading} data={data} />

      {/* TAGS CARD */}
      <Card title={<div className="text-muted">{translateX('tags')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleSelect
              name="tags"
              label="tags"
              mode="tags"
              allowClear
            />
          </Col>
        </Row>
      </Card>

      {/* TECHNICAL REFERENCES CARD */}
      <ReferencesCard data={data} disabled={disabled} onRefresh={refresh} />

      {/* SEARCH TERMS CARD */}
      <SearchTermsCard />

      {/* NOTES CARD */}
      <Card title={<div className="text-muted">{translateX('notes')}</div>}>
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleInput name="note" label="notes" type="textarea" rows={4} />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ToolboxReferencesTab;

// *******************************************************************************
// HELPERS
// *******************************************************************************
